// Single source of truth for the app's navigation. Used by both the sidebar
// (AdminLayout.jsx) and the Dashboard's permission-filtered link list (AdminPanel.jsx).
// screenKey must match Role_Permission.Screen_Key for permission filtering to work.
// to: null means the page isn't built yet - it never shows anywhere, regardless of permission.
export const MENU = [
  {
    section: "Master",
    items: [
      { label: "Party Master", to: "/party-master", screenKey: "party-master" },
      { label: "Product Master", to: "/product-master", screenKey: "product-master" },
      { label: "Employee Master", to: "/admin/Employee", screenKey: "employee-master" },
      { label: "Company Master", to: null },
      { label: "Tax Master", to: null },
      { label: "Parameters", to: null },
    ],
  },
  {
    section: "Transactions",
    items: [
      { label: "AWB In Entry", to: "/admin/AwbIn", screenKey: "awb-in" },
      { label: "AWB Out Entry", to: null },
      { label: "Party Transaction", to: "/admin/partytransaction", screenKey: "party-transaction" },
      { label: "Create Bill", to: "/admin/CreateBill", screenKey: "party-transaction" },
      { label: "Create Bill with SP", to: "/admin/CreateBillWithSp", screenKey: "party-transaction" },
    ],
  },
  {
    section: "Reports",
    items: [
      { label: "Invoice Print", to: "/reports", screenKey: "reports" },
      { label: "AWB List Print", to: null },
      { label: "Ledger", to: "/reports", screenKey: "reports" },
    ],
  },
  {
    section: "Final Reports",
    items: [
      { label: "Opening Trial Balance", to: null },
      { label: "Trial Balance", to: null },
      { label: "Profit & Loss A/c", to: "/reports", screenKey: "reports" },
      { label: "Balance Sheet", to: "/reports", screenKey: "reports" },
    ],
  },
  {
    section: "GST Reports",
    items: [{ label: "GST Excel Sheet", to: null }],
  },
  {
    section: "Other Reports",
    items: [
      { label: "Customer List", to: null },
      { label: "Employee List", to: null },
    ],
  },
  {
    section: "Utility",
    items: [
      { label: "Backup", to: null },
      { label: "Recalculations", to: null },
      { label: "WhatsApp Message", to: null },
    ],
  },
  {
    section: "Administration",
    items: [
      { label: "Account Management", to: "/admin/Account", screenKey: "account-management" },
      { label: "User Management", to: "/admin/CreateUser", screenKey: "user-management" },
      { label: "Role Management", to: "/admin/RoleManagement", screenKey: "role-management" },
      { label: "Import Data", to: "/admin/import", screenKey: "import" },
    ],
  },
];